export default "__VITE_ASSET__gP0pp_Ss__"